import React from 'react';
import { IndeedThemeProvider } from '@indeed/ifl-components';
import { aurora } from '@indeed/ifl-themes';
const ThemeProvider = ({ children }) => (React.createElement(IndeedThemeProvider, { theme: {
        ...aurora,
        fonts: {
            default: '"Hiragino Sans", Noto, "Noto Sans CJK JP", "Helvetica Neue", Helvetica, Arial, "Liberation Sans", Roboto, sans-serif'
        }
    } }, children));
export default ThemeProvider;
